module.exports = __webpack_public_path__ + "img/lp-mobile-phone-image.ad35d63a.png";